<template>
  <section class="section">
    <div class="container">
      <Title>Users <Plus @click="showAdd = true"></Plus></Title>

      <div class="loading" ng-show="!firstLoadDone"></div>
      <p class="is-italic" v-if="firstLoadDone && items.length === 0">
        <i>No users.</i>
      </p>

      <div
        class="columns is-multiline"
        v-show="firstLoadDone && items.length != 0"
      >
        <div
          class="column is-one-third-widescreen is-unselectable"
          v-for="item of items"
          :key="item.user.uid"
        >
          <div class="card">
            <header class="card-header" @click="toggle(item)">
              <div class="card-header-title">
                <span class="icon"> <i class="mdi mdi-account"></i> </span
                >{{ item.user.mail }}
              </div>

              <a class="card-header-icon" aria-label="show more">
                <span class="icon">
                  <i
                    class="mdi"
                    :class="{
                      'mdi-chevron-down': !item.visible,
                      'mdi-chevron-up': item.visible,
                    }"
                    aria-hidden="true"
                  ></i>
                </span>
              </a>
            </header>
            <div class="card-content" v-show="item.visible">
              <table class="table is-narrow is-fullwidth">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Permission</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>Domain</td>
                    <td>{{ domain.friendlyName }}</td>
                    <td>
                      {{ domainPermission(domain) }}
                    </td>
                  </tr>
                  <tr v-for="source of item.sources" :key="source.uid">
                    <td>Repository</td>
                    <td>{{ source.name }}</td>
                    <td>
                      {{ sourcePermission(source) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <footer class="card-footer" v-show="item.visible">
              <a
                v-if="!item.isLoading"
                class="card-footer-item"
                @click="
                  selected = item;
                  showDelete = true;
                "
                :disabled="domain.permission && domain.permission < 256"
                >Stop share</a
              >
              <a
                v-if="item.isLoading"
                class="card-footer-item spinner-wrapper center"
              >
                <span class="spinner is-centered"></span>
              </a>
            </footer>
          </div>
        </div>
      </div>
    </div>
    <Share
      v-if="domain && showAdd"
      v-model="showAdd"
      :domain="domain"
      :sources="$store.state.source.sources"
      @hide="selected = null"
      @change="getUsers()"
    ></Share>

    <Confirm
      v-if="selected && showDelete"
      v-model="showDelete"
      @hide="selected = null"
      @confirmed="removeShare(selected)"
    >
      You are about to stop sharing the domain
      <i>{{ domain.friendlyName }}</i> with {{ selected.user.mail }}.
    </Confirm>
  </section>
</template>

<script>
import { postApi } from "@/utils/http";
import permissions from "@/utils/permission.js";

export default {
  components: {
    Title: () => import("@/components/singles/Title.vue"),
    Plus: () => import("@/components/main/Plus.vue"),
    Share: () => import("@/components/main/domain/Share.vue"),
    Confirm: () => import("@/components/main/Confirm.vue"),
  },
  data() {
    return {
      items: [],
      domain: null,
      firstLoadDone: false,
      showDelete: false,
      selected: null,
      showAdd: false,
    };
  },
  async created() {
    await this.getDomain();
    await this.getUsers();
    await this.getSources();
    this.firstLoadDone = true;
  },
  computed: {
    domainPermission() {
      return (domain) => {
        if (domain.permission) return permissions.domain[domain.permission];
        else return "Owner";
      };
    },
    sourcePermission() {
      return (source) => {
        if (source.permission) return permissions.source[source.permission];
      };
    },
  },
  methods: {
    toggle(item) {
      const index = this.items.findIndex((x) => x.user.uid === item.user.uid);
      this.$set(this.items, index, { ...item, visible: !item.visible });
    },
    async removeShare(item) {
      const index = this.items.findIndex((x) => x.user.uid === item.user.uid);
      this.$set(this.items, index, { ...item, isLoading: true });

      const res = await postApi("delete/domainShare", {
        domainUID: this.domain.uid,
        userUID2: item.user.uid,
      });

      this.$delete(this.items, index);
      this.showDelete = false;
      this.selected = null;
    },
    async getSources() {
      await this.$store.dispatch("source/fetch", {
        domainUID: this.$route.params.domainUID,
      });
    },
    async getDomain() {
      await this.$store.dispatch("domain/fetch");
      this.domain = this.$store.getters["domain/single"](
        this.$route.params.domainUID
      );
    },
    async getUsers() {
      const res = await postApi("get/sharedDomainsAndUsers", {
        domainUID: this.$route.params.domainUID,
      });

      this.items = res;
    },
  },
};
</script>
